import { render, staticRenderFns } from "./Telesales.vue?vue&type=template&id=7787765d&scoped=true"
import script from "./Telesales.vue?vue&type=script&lang=js"
export * from "./Telesales.vue?vue&type=script&lang=js"
import style0 from "./Telesales.vue?vue&type=style&index=0&id=7787765d&prod&lang=scss&scoped=true"
import style1 from "./Telesales.vue?vue&type=style&index=1&id=7787765d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7787765d",
  null
  
)

export default component.exports